module.exports = __webpack_public_path__ + "h5/img/yiqian.a391690d.png";